export default __webpack_public_path__ + "static/media/mobNFLCardBg.fc134962.png";